import { Link } from 'react-router-dom';

export default function Footer() {
  // アニメーション用の共通クラス（左から右へ伸びる 1px の下線）
  const hoverUnderlineClass = "relative inline-block after:content-[''] after:absolute after:bottom-[-2px] after:left-0 after:w-full after:h-[1px] after:bg-gray-900 after:scale-x-0 after:origin-left after:transition-transform after:duration-300 hover:after:scale-x-100";

  return (
    <footer className="bg-[#F7F6F3] border-t border-gray-200/60">
      <div className="site-container py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16">
          
          {/* 左側：ロゴエリア - SWELL GROUP (Topへのリンク) */}
          <div className="md:col-span-4 lg:col-span-5">
            <Link
              to="/"
              className="text-[16px] font-semibold tracking-[0.12em] text-gray-900 transition-opacity hover:opacity-70"
              style={{ fontFamily: "'Josefin Sans', sans-serif" }}
            >
              SWELL GROUP
            </Link>
          </div>

          {/* 中央：GROUP (並び順と表記を修正) */}
          <div className="md:col-span-4 lg:col-span-3">
            <h4 className="text-[11px] tracking-[0.2em] font-semibold text-gray-400 mb-6 uppercase">
              Group
            </h4>
            <div className="flex flex-col items-start gap-3">
              <Link to="/company/swell-holdings" className={`text-[13px] text-gray-600 hover:text-gray-900 transition-colors ${hoverUnderlineClass}`}>
                SWELL HOLDINGS
              </Link>
              <Link to="/company/swell-partners" className={`text-[13px] text-gray-600 hover:text-gray-900 transition-colors ${hoverUnderlineClass}`}>
                SWELL PARTNERS
              </Link>
              <Link to="/company/swell-coffee" className={`text-[13px] text-gray-600 hover:text-gray-900 transition-colors ${hoverUnderlineClass}`}>
                SWELL COFFEE ROASTERS
              </Link>
              <Link to="/company/rice-ball" className={`text-[13px] text-gray-600 hover:text-gray-900 transition-colors ${hoverUnderlineClass}`}>
                RICEBALL PLANNING
              </Link>
            </div>
          </div>

          {/* 右側：ASSOCIATES */}
          <div className="md:col-span-4 lg:col-span-4">
            <h4 className="text-[11px] tracking-[0.2em] font-semibold text-gray-400 mb-6 uppercase">
              Associates
            </h4>
            <div className="flex flex-col items-start gap-3">
              <Link to="/company/meet" className={`text-[13px] text-gray-600 hover:text-gray-900 transition-colors ${hoverUnderlineClass}`}>
                MEET
              </Link>
            </div>
          </div>

        </div>
      </div>

      <div className="border-t border-gray-200/60">
        <div className="site-container py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[11px] tracking-wider text-gray-400">
            © {new Date().getFullYear()} SWELL HOLDINGS Co.,Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
